import axios from 'axios';

const instance = axios.create({ baseURL: 'https://caribe-match-16ea20519505.herokuapp.com/' })


export default instance;


